import type { FC } from 'react'
import { formatApiDate } from '~/shared/lib/date'
import { Box, Typography, useTheme } from '@mui/material'
import Highlighter from 'react-highlight-words'
import Button from '@mui/material/Button'
import { ChatSearchRetrieveResponse } from '@fireflyhealth/api'

import { UserAvatar } from '~/shared/ui'
type ChatSearchResult = ChatSearchRetrieveResponse['results'][number]

interface ChatSearchResultSingleProps {
  id: number
  searchQuery: string
  result: ChatSearchResult
  handleResultClick: (key: number) => void
}

const ChatSearchResultSingle: FC<ChatSearchResultSingleProps> = (
  props: ChatSearchResultSingleProps,
) => {
  const { id, searchQuery, result, handleResultClick } = props
  const theme = useTheme()
  const highlightStyle = { backgroundColor: theme.palette.background.highlight }
  const sentDate = formatApiDate(result.sent_at, "MMM.dd 'at' h:mmaaa") ?? ''
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '1em',
        borderBottom: '0.1rem solid',
        borderBottomColor: 'divider',
      }}
    >
      <Button
        sx={{
          display: 'flex',
          justifyContent: 'left',
          textTransform: 'none',
          '&:hover': { backgroundColor: 'transparent' },
          width: '100%',
        }}
        onClick={() => handleResultClick(id)}
      >
        <div>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <UserAvatar id={result.sender.id} size="large" />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'left',
                fontWeight: 400,
                lineHeight: 1.3,
              }}
            >
              <div>
                <Highlighter
                  highlightTag="span"
                  highlightStyle={highlightStyle}
                  searchWords={[searchQuery]}
                  textToHighlight={result.sender.first_name_used}
                />
              </div>
              <div>{sentDate}</div>
            </Box>
          </Box>
          <Typography sx={{ display: 'flex', margin: '0 1em', textAlign: 'left' }}>
            <Highlighter
              highlightTag="span"
              highlightStyle={highlightStyle}
              searchWords={[searchQuery]}
              textToHighlight={result.text ?? ''}
            />
          </Typography>
        </div>
      </Button>
    </Box>
  )
}

export default ChatSearchResultSingle
